import React, { useEffect, useState } from 'react';
import { post } from 'store/request';
import './index.scss';
import { useTypedSelector, useAppDispatch } from 'store/index';
import { activeAccountTypeKey2Val } from 'common/const';
import dialog from 'utils/dialog';
import { logout } from 'store/user';

// eslint-disable-next-line react/display-name
export default () => {
  const { accountList } = useTypedSelector((state) => state.user);
  const [list, setList] = useState([]);
  const dispatch = useAppDispatch();

  const chooseUser = (id) => {
    post('/select_active_account', { account_id: id }).then(() => {
      window.location.replace('/');
    });
  };

  useEffect(() => {
    setList(accountList);
    console.log('accountList', accountList);
    if (accountList?.length === 1) {
      chooseUser(accountList[0].account_id);
    }
    // 普通用户 accountList 为空数组 传0
    if (!accountList || accountList?.length === 0) {
      dialog.alert(
        <div>
          无可用账号信息，请前往投放后台
          <a href="https://ad.qq.com/" target="_self">
            （ad.qq.com）
          </a>
          关联或者注册广告账号。
        </div>,
        {
          title: '无可用账号信息',
        }
      );
      dispatch(logout());
    }
    /* eslint-disable-next-line react-hooks/exhaustive-deps*/
  }, [accountList]);

  return (
    <div className="login-portal-content">
      <div className="login-logo">
        <a href="https://e.qq.com" />
      </div>
      <div className="choose-ac">
        <div className="ac-body">
          <div className="acc-tittle">请选择账户登录</div>

          <div className="choose-tableBlock">
            <div className="ac-ul">
              {list?.map((item, index) => (
                <div className="ac-tableLine" key={index} onClick={() => chooseUser(item.account_id)}>
                  <div className="actname" title={item.nick_name}>
                    {item.nick_name}
                  </div>

                  <div className="actname">{activeAccountTypeKey2Val[item.account_type] || '-'}</div>

                  <div className="actid">ID:{item.account_id}</div>

                  {/* <div className="actcha" title="自定义角色，管理员">*/}
                  {/*  自定义角色，管理员*/}
                  {/* </div>*/}
                  <div className="actcha" />

                  <div className="actarrow">
                    <div className="arrow" />
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
